import { toast } from "react-toastify";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FullScreenLoader, PageTitle } from "components";
import { useGetACompanyQuery, useGetCompanyApiKeyQuery, useUpdateCompanyMutation } from "redux/api/companyApi";
import {Company}  from "components/Company";
import { useGetAllProvincesQuery } from "redux/api/provinceApi";
import { ISelectOption } from "Interfaces/Utils";
import { useIntl } from "react-intl";

// Static vars

const RETURN_PAGE = "/companies";

/**
 * Component to render news edit view
 */

export const CompanyEditPage = () => {
  const { formatMessage } = useIntl();
  const PAGE_TITLE = formatMessage({ id: "company.edit" });
  const RETURN_LABEL = formatMessage({ id: "company.back" });
  const UPDATE_SUCCESS = formatMessage({ id: "company.updatedSuccessfuly" });

  const { companyId } = useParams();

  const navigate = useNavigate();

  // API calls
  
  const { data: company, isLoading: isCompanyLoading } = useGetACompanyQuery(String(companyId));
  const [ updateCompany, { data: UpdatedCompanyData, isSuccess: isUpdatedCompanySuccess, error: apiError } ] = useUpdateCompanyMutation();
  const {data: provinces, isLoading: isProvincesLoading} = useGetAllProvincesQuery();
  const { data: companyToken } = useGetCompanyApiKeyQuery(String(companyId));
  // UseEffect to manage update success

  useEffect(() => {
    if (isUpdatedCompanySuccess && UpdatedCompanyData) {
      toast.success(UPDATE_SUCCESS);
      navigate(RETURN_PAGE);
    }
  }, [isUpdatedCompanySuccess, UpdatedCompanyData, navigate]);

  // Function to update news with form results

  const provinceSelectOptions: ISelectOption[] = useMemo(() => {
      
    if (!provinces) return [];    
     return provinces.map((province) => ({
      label: province.name,
      value: province._id,
    }));
  }, [provinces])

  const updateCompanyHandler = (formData: FormData) => {
    updateCompany({ id: String(companyId), newsToUpdate: formData });
  };  

  if (isCompanyLoading||isProvincesLoading) return <FullScreenLoader />;

  return (
    <>
      <PageTitle
        pageTitle={PAGE_TITLE}
        returnPage={RETURN_PAGE}
        returnLabel={RETURN_LABEL}
      />
      
      <Company.Form
        provinces={provinceSelectOptions}
        onSubmit={updateCompanyHandler}
        currentCompany={company}
        apiError={apiError}
        companyKey={companyToken?.token}
      />
    </>
  );
};
